import { render, staticRenderFns } from "./view-mail-modal.vue?vue&type=template&id=e4c85400&scoped=true"
import script from "./view-mail-modal.vue?vue&type=script&lang=js"
export * from "./view-mail-modal.vue?vue&type=script&lang=js"
import style0 from "./view-mail-modal.vue?vue&type=style&index=0&id=e4c85400&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c85400",
  null
  
)

export default component.exports